export const isAdminAndVisitingAddressSame = (company: server.dto.Company): boolean =>
  (company.address.formatted.every((addressLine, idx) => company.admAddress.formatted[idx] === addressLine)) && company.name === company.admName;

export const hasStageDimensions = (stage: {
  width: number | string;
  depth: number | string;
  toFloor: number | string;
  toCeiling: number | string;
} | undefined): boolean =>
  Boolean(stage && (stage.width || stage.depth || stage.toFloor || stage.toCeiling));

/**
 * @deprecated This should not be used. We should not convert betweend CompanySmall and ArtistSmall instead we should just use ArtistSmall
 **/
export const companyToArtist = (company: server.dto.CompanySmall | server.dto.Company): server.dto.ArtistSmall | undefined => {
  if (company == null) return undefined;

  return {
    artistId: company.companyId,
    name: company.name,
  }
}

export const toCompanySmall = (company: server.dto.Company): server.dto.CompanySmall | undefined => {
  if (company == null) return undefined;

  return {
    companyId: company.companyId,
    name: company.name,
    isValidated: company.isValidated,
    address: company.address
  }
}